import { Button } from '@material-ui/core';
import { FC } from 'react';
import { useStyles } from '../useStyles';

export type Props = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
  children?: React.ReactNode;
};

export const EditButton: FC<Props> = props => {
  const { children, onClick, className } = props;
  const classes = useStyles();
  return (
    <Button
      onClick={onClick}
      variant='contained'
      color='secondary'
      className={`${classes.editStyle} ${className}`}
    >
      {children}
    </Button>
  );
};
